import { NgModule,DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinanceiroRoutingModule } from './financeiro-routing.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { TooltipModule } from 'primeng/tooltip';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { InputMaskModule } from 'primeng/inputmask';
import { ExtratoFinanceiroComponent } from './extrato-financeiro/extrato-financeiro.component';
import { QRCodeModule } from 'angularx-qrcode';
import { PrestacaoContaComponent } from './prestacao-conta/prestacao-conta.component';
import { PanelModule } from 'primeng/panel';



@NgModule({
  declarations: [
    ExtratoFinanceiroComponent,
    PrestacaoContaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,

    DialogModule,
    TableModule,
    DropdownModule,
    CalendarModule,
    InputTextModule,
    CurrencyMaskModule,
    TooltipModule,
    InputTextareaModule,
    CheckboxModule,
    InputMaskModule,
    QRCodeModule,
    PanelModule,
    
    SharedModule,

    FinanceiroRoutingModule,
  ]
 
})
export class FinanceiroModule { }
